import { FGDateMaskInput, FGSelectInput, FGTextInput, FieldGroup } from "nsitools-react";
import * as React from "react";

import { FGPeopleSearchInput, FGSRSHDateMaskInput } from "../../../../../components";
import { useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

export interface IDrupalCompetitionClubValidationProps {
  activities: any;
  aloading: boolean;
  subActivities: any;
  saloading: boolean;
  sections: any;
  sloading: boolean;
  clubId: number;
  clubs: any;
  cloading: boolean;
}

export const DrupalCompetitionClubValidation: React.FunctionComponent<IDrupalCompetitionClubValidationProps> = ({
  activities,
  aloading,
  subActivities,
  saloading,
  sections,
  sloading,
  clubId,
  clubs,
  cloading,
}) => {
  const { t } = useTl();
  return (
    <FieldGroup columns={2}>
      <FieldGroup>
        <FGSelectInput name="clubId" readonly label={t(ETLCodes.Club)} items={clubs} loading={cloading} />
        <FGPeopleSearchInput
          name="request.personId"
          label={t(ETLCodes.Contact)}
          clubId={clubId ?? -1}
          disabled={!clubId}
          requiredMark
          readonly
        />
        <FGTextInput name="clubEmail" label={t(ETLCodes.ClubEmail)} readonly />
      </FieldGroup>
      <FieldGroup>
        <FGSRSHDateMaskInput name="dateFrom" label={t(ETLCodes.DateFrom)} requiredMark readonly />
        <FGSRSHDateMaskInput name="dateTo" label={t(ETLCodes.DateTo)} requiredMark readonly />
        <FGSelectInput
          name="sectionId"
          label={t(ETLCodes.Section)}
          items={sections}
          loading={sloading}
          requiredMark
          readonly
        />
        <FGSelectInput
          name="activityId"
          label={t(ETLCodes.Activity)}
          items={activities}
          loading={aloading}
          requiredMark
          readonly
        />
        <FGSelectInput
          name="subActivityId"
          label={t(ETLCodes.SubActivity)}
          items={subActivities}
          loading={saloading}
          requiredMark
          readonly
        />
        <FGTextInput name="extra" label={t(ETLCodes.Extra)} readonly />
      </FieldGroup>
    </FieldGroup>
  );
};
